'use strict';

(function (window, $) {
    var $showMore = $('.jwsdw-loadMore-button'),
        $searchForm = $('#jwsdw-career-searchForm'),
        $searchInput = $('#jwsdw-career-search input'),
        $department = $('#jwsdw-career-department'),
        $entryLevel = $('#jwsdw-career-entryLevel'),
        $placeOfWork = $('#jwsdw-career-placeOfWork'),
        $searchButton = $('#jwsdw-career-search button'),
        $searchResults = $('#jwsdw-career-searchResults'),
        $progressBarContainer = $('.jwsdw-career-progressBar'),
        $jobsShown = $('.jwsdw-progressBar-shown'),
        $jobsTotal = $('.jwsdw-progressBar-results'),
        $jobCards = $('.jwsdw-career-jobCards'),
        $fillProgressBar = $('.jwsdw-progressBar-fill'),
        $jobListingTemplate = $('.jwsdw-career-jobTemplate'),
        $noResultsTemplate = $('.jwsdw-career-noResults-template'),
        state = {
            'query': $searchInput.val(),
            'activity': $department.val(),
            'entryLevel': $entryLevel.val(),
            'placeOfWork': $placeOfWork.val()
        };

    $searchForm.on('submit', search);
    $searchInput.on('keyup', window.jwsdwUtil.debounce(650, search));
    $searchButton.on('click', search);

    $department.on('change', search);
    $entryLevel.on('change', search);
    $placeOfWork.on('change', search);

    $(window).on('popstate', function () {
        if (window.history.state) {
            state = window.history.state;
            $searchInput.val(state.query);
            $department.val(state.activity);
            $entryLevel.val(state.entryLevel);
            $placeOfWork.val(state.placeOfWork);

            search(null, true);
        }
    });

    /**
     * @description Method to perform search request
     * @param {Object} e event object
     * @param {Boolean} popState true if triggered by popState
     * @return {void}
     */
    function search (e, popState) {
        var url = $searchForm.attr('action');

        if (e) {
            e.preventDefault();
        }
        state.query = $searchInput.val();
        state.activity = $department.val();
        state.entryLevel = $entryLevel.val();
        state.placeOfWork = $placeOfWork.val();
        url = buildUrlParameters(state);
        if (!popState) {
            window.history.pushState(state, $(document).find('title').text(), url);
        }
        $.ajax({
            'type': 'GET',
            'format':'ajax',
            'url': window.jwsdwSettings.baseUrl + '/Career-findJobs',
            'data': state,
            'beforeSend': function() {
                $searchButton.find('.jwsdw-spinner').removeClass('jws-hidden');
                $searchButton.find('svg').addClass('jws-hidden');
            },
            'success': function(data) {
                var $noResults = $noResultsTemplate.clone(),
                    $section = $('.jwsdw-career-jobCards');

                $section.find('.jwsdw-career-jobInfo, .jwsdw-career-noResults').remove();
                $('jwsdw-loadMore').removeClass('jws-hidden');

                if (data.length > 0) {
                    data.forEach(function(jobListing, index) {
                        var $jobListing = $jobListingTemplate.clone(),
                            baseUrl = $('.jwsdw-career-jobInfo-link').data('base-url');

                        $jobListing.find('.jwsdw-career-jobInfo-link').attr('href', baseUrl + jobListing.jobDetailsUrl);
                        $jobListing.find('.jwsdw-career-jobInfo-title').text(jobListing.jobTitle);
                        $jobListing.find('.jwsdw-career-jobInfo-department').text(jobListing.department);
                        $jobListing.find('.jwsdw-career-jobInfo-entryLevel').text(jobListing.entryLevel);
                        $jobListing.find('.jwsdw-career-jobInfo-placeOfWork').text(jobListing.placeOfWork);
                        if (index < 10) {
                            $jobListing.removeClass('jws-hidden jwsdw-career-jobTemplate');
                            updateResultsProgressBar(data.length, index + 1);
                        }
                        $searchResults.append($jobListing);
                        $progressBarContainer.removeClass('jws-hidden');
                        $noResults.addClass('jws-hidden');
                    });
                } else {
                    $noResults.removeClass('jws-hidden');
                    $progressBarContainer.addClass('jws-hidden');
                    $searchResults.append($noResults);
                }

                if (data.length > 10) {
                    $showMore.removeClass('jws-hidden');
                } else {
                    $showMore.addClass('jws-hidden');
                }
            },
            'complete': function() {
                $searchButton.find('.jwsdw-spinner').addClass('jws-hidden');
                $searchButton.find('svg').removeClass('jws-hidden');
            }
        });
    }

    /**
     * @description Method to build Url Parameters from obj
     * @param {Object} obj the object
     * @returns {String} url with url parameters
     */
    function buildUrlParameters(obj) {
        var url = '',
            params = [];

        params = Object.keys(obj)
            .filter(function(key) {
                return obj[key];
            })
            .sort(function(a, b) {
                return a > b ? 1 : -1;
            })
            .map(function(key) {
                return key + '=' + obj[key];
            });
        if (params.length > 0) {
            url = '?' + params.join('&');
        }
        return url;
    }

    // handler for loading more jobs
    $jobCards.on('click', '.jwsdw-loadMore-button', function () {
        var $button = $(this),
            pageSize = $button.data('pageSize'),
            page = $button.data('page') + 1,
            $progressBar = $button.parents('.jwsdw-loadMore').find('.jwsdw-progressBar'),
            jobsTotal = parseInt($button.parents('.jwsdw-loadMore').find('.jwsdw-progressBar-results').text()),
            jobsDisplayed = Math.min(page * pageSize, jobsTotal),
            $jobs = $button.parents('.jwsdw-career-jobCards').find('.jwsdw-career-jobInfo');

        $jobs.each(function (i) {
            if (i < page * pageSize) {
                $(this).removeClass('jws-hidden');
            }
        });

        $progressBar.find('.jwsdw-progressBar-fill').css('width', jobsDisplayed / jobsTotal * 100 + '%');
        $jobsShown.text(jobsDisplayed);
        $button.data('page', page);

        if (jobsDisplayed === jobsTotal) {
            $button.addClass('jws-hidden');
        }
    });

    /**
     * @description Method to update progress bar after using filters
     * @param {Number} totalJobs total amount of jobs
     * @param {Number} shownJobs amount of shown jobs
     * @returns {void}
     */
    function updateResultsProgressBar (totalJobs, shownJobs) {
        $jobsShown.text(shownJobs);
        $jobsTotal.text(totalJobs);
        $fillProgressBar.width(Math.round(shownJobs / totalJobs * 100) + '%');
    }

}(window, jQuery));